import { Injectable } from '@angular/core';


@Injectable()
export class SignaturePadService {
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./lib/src/signature-pad/signature-pad.service.ts